import React from 'react';
import FullscreenShareButtons from './fullscreenShareButtons.js';
import FullscreenCartButton from './fullscreenCartButton.js';
import FullscreenCheckoutLink from './fullscreenCheckoutLink.js';
import FullscreenShop from '../../store/applications/gallery/fullscreenShop.js';
import {storePubSub} from '../../store/applications/consts.js';
import { utils, TranslationUtil } from '../../utils';
import { versionManager, VersionManagerCore } from '../../versioning/proGalleryVersionManager.js';
import mobileViewTypes from 'wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes';

class FullscreenSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isStoreGallery: utils.isStoreGallery(),
      isSmallScreen: utils.isSmallScreen(),
      isMobile: utils.isMobile(),
      isStoreMobile: utils.isStoreGallery() && utils.isMobile(),
      isReadMoreVisible: false,
      isReadMoreOpen: false,
    }
  }

  fixTextsLineHeight(isReadMoreOpen) {
    var elem = this.itemContainer
    var title = $(elem).find('.fullscreen-side-bar-title')
    var description = $(elem).find('.fullscreen-side-bar-description')
    var availableHeight = 150
    var numberOfLinesRequired = 3
    var spaceBetweenTitleAndDescription = 0
    var originalTitleHeight = 0
    var originalDescriptionHeight = 0

    var titleLineHeight = parseInt(title.css('line-height')) || 0
    var numOfTitleLines = 0
    var numOfDescriptionLines = 0

    // reset truncation stuff
    title.css({ height: 'initial' })
    description.css({ height: 'initial' })
    title.css({ '-webkit-line-clamp': 'initial' })
    description.css({ '-webkit-line-clamp': 'initial' })

    if (title && title[0]) {
      // originalTitleHeight = title[0].scrollHeight - 18 //substructing the title margin-bottom
      originalTitleHeight = title[0].scrollHeight
    }
    if (description && description[0]) {
      // originalDescriptionHeight = description[0].scrollHeight - 24 //substructing the description margin-bottom
      originalDescriptionHeight = description[0].scrollHeight
    }

    if (!isReadMoreOpen) {
      var titleText = this.props.current.item.title || this.props.fileName;
      if (this.props.styleParams.allowTitleExpand && titleText) {
        if (title && title.length != 1) {
          return
        }

        spaceBetweenTitleAndDescription = 30;

        numOfTitleLines = this.truncateElement(availableHeight, numberOfLinesRequired, title, originalTitleHeight)
        let titleHeight = numOfTitleLines * titleLineHeight

        if (availableHeight > titleHeight) {
          availableHeight -= titleHeight;
        } else {
          availableHeight = 0;
        }
      }

      if (this.props.styleParams.allowDescriptionExpand && this.props.current.item.description) {
        if (description && description.length != 1) {
          return
        }

        availableHeight -= spaceBetweenTitleAndDescription;

        if (availableHeight <= 0) {
          description.hide();
          return;
        }

        numOfDescriptionLines = this.truncateElement(availableHeight, (numberOfLinesRequired - numOfTitleLines), description, originalDescriptionHeight)

        if (numOfDescriptionLines == 0) {
          description.hide();
        }
      }
    } else {
      //all the title and description should be displayed
      if (this.props.current.item.isReadMoreOpen) {
        this.setState({ isReadMoreVisible: true });
      }
      title.css({ height: originalTitleHeight })
      description.css({ height: originalDescriptionHeight })
      description.show()
      title.css({ '-webkit-line-clamp': 'initial' })
      description.css({ '-webkit-line-clamp': 'initial' })
    }
  }

  truncateElement(availableHeight, numberOfLinesRequired, element, originalElementHeight) {
    var numOfElementLines = 0

    element.css({ 'overflow': 'visible' })
    var elementHeight = originalElementHeight
    var elementLineHeight = parseInt(element.css('line-height')) || 0
    var originalNumberOfElementLines = Math.floor(elementHeight / elementLineHeight)
    numOfElementLines = Math.min(Math.floor(availableHeight / elementLineHeight), numberOfLinesRequired, originalNumberOfElementLines)

    if (numOfElementLines < originalNumberOfElementLines) {
      //need to truncate the element
      this.props.current.item.isReadMoreOpen = false
      this.setState({ isReadMoreOpen: false })
      this.setState({ isReadMoreVisible: true })

      element.css({ '-webkit-line-clamp': (numOfElementLines + '') })
      elementHeight = elementLineHeight * numOfElementLines
      element.css({ 'overflow': 'hidden', 'display': '-webkit-box', '-webkit-box-orient': 'vertical', height: elementHeight })
    } else {
      //all the element can be displayed
      if (this.props.current.item.isReadMoreOpen) {
        this.setState({ isReadMoreVisible: true })
      }
      element.css({ '-webkit-line-clamp': 'initial' });
      elementHeight = elementLineHeight * originalNumberOfElementLines
    }
    return numOfElementLines
  }

  toggleReadMore() {
    this.props.current.item.isReadMoreOpen = !this.props.current.item.isReadMoreOpen;
    this.setState({ isReadMoreOpen: this.props.current.item.isReadMoreOpen });
    this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
  }

  handleSetMobileData(type, data) {
    const onSetMobileData = this.props.onSetMobileData;
    if (onSetMobileData) {
      onSetMobileData(type, data);
    }
  }

  postShopRequest(type, data) {
    if (this.shopElement) {
      this.shopElement.postShopRequest(type, data);
    }
  }

  addToCartRequest() {
    if (this.shopElement) {
      this.shopElement.addToCartRequest();
    }
  }

  isVisible() {
    return ((this.props.showInfo && this.props.current.hasInfo) || (this.state.isStoreGallery && !this.state.isSmallScreen) || (this.props.showMobileShopFrame === true));
  }

  componentDidUpdate(prevProps, prevState) {
    // if (!utils.isSmallScreen()) {
    //   // $(".fullscreen-side-bar-info-container").mCustomScrollbar({
    //   //   theme:"dark"
    //   // });
    // }

    if (utils.isStoreGallery()) {
      if (prevProps.current.item.id !== this.props.current.item.id) { // we are dealing with a new item
        if (this.state.isReadMoreVisible) {
          this.setState({ isReadMoreVisible: false })
        }
        this.setState({ isReadMoreOpen: this.props.current.item.isReadMoreOpen });
        this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
      }
    }

    // if (utils.isAccessibilityEnabled()) {
    //   if (this.titleElement && this.isVisible() && !prevProps.showInfo) {
    //     this.titleElement.focus();
    //   }
    // }
  }

  componentDidMount() {
    if (utils.isStoreGallery()) {
      this.fixTextsLineHeight(this.curItem.isReadMoreOpen)
    }
  }

  render() {
    const curItem = this.curItem = this.props.current.item;
    const isImage = (curItem.type === 'image') || (curItem.type ==='picture');
    const { isReadMoreVisible, isStoreGallery, isSmallScreen, isMobile, isStoreMobile, isReadMoreOpen } = this.state;

    var titleText = curItem.title || curItem.fileName || ''; //(curItem.isDemo ? curItem.demoTitle : ''); - remove default text from demo items until rewritten
    var title = (titleText && this.props.styleParams.allowTitleExpand && !isStoreMobile) ? (
      <div className="fullscreen-side-bar-title"
        tabIndex={this.isVisible() ? utils.getTabIndex('fullscreenTitle') : -1}
        aria-label={titleText}
        ref={title => this.titleElement = title}
      >
        {titleText}
      </div>
    ) : null;

    var descriptionText = curItem.description || ''; //(curItem.isDemo ? curItem.demoDescription : ''); - remove default text from demo items until rewritten
    var descriptionTextArray = descriptionText.split('\n');
    var description;
    if (descriptionText && this.props.styleParams.allowDescriptionExpand && !isStoreMobile) {
      var descriptionElementsArray = [];
      for (let i = 0; i < descriptionTextArray.length; i++) {
        descriptionElementsArray.push(<div className="fullscreen-side-bar-description-line" key={"description_" + i}>
          {descriptionTextArray[i]}
        </div>)
      }

      let descriptionClassName = "fullscreen-side-bar-description";
      descriptionClassName += (isStoreGallery ? ' store' : '');
      description = (
        <div className={descriptionClassName}
           tabIndex={this.isVisible() ? utils.getTabIndex('fullscreenDesc') : -1}
           ref={desc => this.descElement = desc}
        >
          {descriptionElementsArray}
        </div>
      )
    } else {
      description = null;
    }

    var prettyExif = '';
    if (curItem.exif) {

      var camera = curItem.exif['Model'];

      //todo - place separators using join

      var focalLength = curItem.exif['FocalLength'] ? (
        <span>{curItem.exif['FocalLength']}mm</span>
      ) : '';
      var fNumber = curItem.exif['FNumber'] ? (
        <span>&nbsp;&nbsp;/&nbsp;&nbsp;ƒ/{curItem.exif['FNumber']}</span>
      ) : '';
      var roundExposureTime = Math.round(1 / Number(curItem.exif['ExposureTime']));
      var exposureTime = (roundExposureTime > 0) ? (
        <span>&nbsp;&nbsp;/&nbsp;&nbsp;1/{roundExposureTime}s</span>
      ) : '';
      var isoSpeed = curItem.exif['IsoSpeed'] ? (
        <span>&nbsp;&nbsp;/&nbsp;&nbsp;ISO {curItem.exif['IsoSpeed']}</span>
      ) : '';

      var showExif = focalLength || fNumber || exposureTime || isoSpeed;

      prettyExif = (showExif && this.props.styleParams.allowExifExpand && !isStoreGallery) ? (
        <div className="fullscreen-side-bar-exif">
          <div className="exif-camera">{camera}</div>
          <div className="exif-shot">
            {focalLength}
            {fNumber}
            {exposureTime}
            {isoSpeed}
          </div>
        </div>
      ) : '';
    }
    /*
     var allExif = [];
     for (var field in curItem.exif) {
     if (curItem.exif.hasOwnProperty(field)) {
     allExif.push(
     <p>{field}: {curItem.exif[field]}</p>
     )
     }
     }

     <p className="exif-more">see all</p>
     <div className="exif-all">
     {allExif}
     </div>
     */

    var linkClassNames = "fullscreen-side-bar-link link";
    linkClassNames += (isStoreGallery ? ' store' : '');

    var link = (curItem.hasLink && this.props.styleParams.allowLinkExpand && !isStoreMobile &&
      (isStoreGallery ? (curItem.hasLink && (!isReadMoreVisible || isReadMoreOpen)) : true)) ? (
      curItem.linkType === 'web' ? (
        <a className={linkClassNames}
           href={curItem.linkUrl}
           target={curItem.linkOpenType}
           tabIndex={this.isVisible() ? utils.getTabIndex('fullscreenLink') : -1}
           aria-label={curItem.linkText}
           >
          {curItem.linkText ? curItem.linkText : curItem.linkUrl}
        </a>
      ) : (
        <a
          className={linkClassNames}
          onClick={() => this.props.actions.navigateToPageByItemLink(curItem)}
          tabIndex={this.isVisible() ? utils.getTabIndex('fullscreenLink') : -1}
          aria-label={curItem.linkText}
        >
          {curItem.linkText ? curItem.linkText : curItem.linkUrl}
        </a>
      )
    ) : '';
    const readLess = TranslationUtil ? TranslationUtil.getByKey('Gallery_Read_Less') : 'read_less'
    const readMore = TranslationUtil ? TranslationUtil.getByKey('Gallery_Read_More') : 'read_more'
    const readMoreText = isReadMoreOpen ? readLess : readMore
    const readMoreOrLess = (isReadMoreVisible) ?
      <div className="read-more fullscreen-side-bar-description" onClick={() => this.toggleReadMore()}>{readMoreText}</div> :
      null

    var sideBarSocial = (this.props.styleParams.allowSocial && !isStoreGallery) ? (
      <div className="fullscreen-side-bar-social"
           style={this.props.styleParams.galleryAlignExpandIcons}
      >
        <div className="fullscreen-social-share-box open">
          <FullscreenShareButtons item={curItem}/>
        </div>
      </div>
    ) : '';

    var separator = isStoreGallery ? null : (<div className="fullscreen-side-bar-separator"></div>);

    var shopFrame = null;
    const isInSettings = utils.isInSettings();

    if (this.props.showShopFrame && isImage) {
      try {
        const galleryId = this.props.galleryId;
        shopFrame = (
          <FullscreenShop
            ref={element => this.shopElement = element}
            item={curItem}
            styleParams={this.props.styleParams}
            additionalParams={_.merge({}, curItem.getDataForShop(), { galleryId })}
            locale={isInSettings ? 'en' : window.siteLocale}
            actions={this.props.actions}
            deviceType={isInSettings ? 'desktop' : utils.getDeviceType()}
            viewMode={isInSettings ? 'editor' : Wix.Utils.getViewMode()}
            onSetMobileData={(type, data) => this.handleSetMobileData(type, data)}
            connectedProviders={this.props.connectedProviders}
            />
        );
      } catch (error) {

      }
    }
    //mobileViewTypes
    //this.state.providerView
    let shopButtons = null;
    const shouldShowShopButtons = (isStoreGallery && !isMobile && isImage);
    if (shouldShowShopButtons) {
      const providerView = this.props.providerView;
      const shouldShowAddToCartButton = providerView && (providerView.type === mobileViewTypes.singleProduct);

      shopButtons = (<div>
        {shouldShowAddToCartButton ? <FullscreenCartButton cartItems={this.props.cartItems} onAddToCartRequest={() => this.props.onAddToCartRequest()} isSettings={this.props.isSettings} styleParams={this.props.styleParams} /> : null}
        <FullscreenCheckoutLink cartItems={this.props.cartItems} onClick={() => {Wix.PubSub.publish(storePubSub.checkout, {}, false);}} />
      </div>);
    }

    let infoContainerClassName = "fullscreen-side-bar-info-container";
    infoContainerClassName += (isStoreGallery ? ' store' : '');
    // infoContainerClassName += (isSmallScreen ? '' : ' mCustomScrollbar custom-scroller');
    infoContainerClassName += (isStoreGallery ? isSmallScreen ? '' : ' custom-scroller' : '');

    return (
      <div
        className={"fullscreen-side-bar" + (this.isVisible() ? ' opened' : ' closed') + (isSmallScreen ? ' mobile' : '') + (isStoreGallery ? ' store' : '')}
        style={{textAlign: this.props.styleParams.galleryAlignExpand}}>
        <div className={infoContainerClassName}>
          <div ref={itemContainer => { this.itemContainer = itemContainer } }>
            {title}
            {description}
          </div>
          {prettyExif}
          {link}
          {readMoreOrLess}
          {versionManager.useFullscreenNewSidebar() ?  false : separator}
          {versionManager.useFullscreenNewSidebar() ? false : sideBarSocial}
          {shopFrame}
        </div>
        {shopButtons}
      </div>
    );
  }
}

export default FullscreenSidebar;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenSidebar.js